<app-attendee-dynamic-page-layout>
  <ng-container *ngIf="cmsPage">
    <app-attendee-jumbotron
      [title]="cmsPage.page_title"
      [description]="cmsPage.jumbotron?.default?.description"
      [textColor]="cmsPage.jumbotron?.default?.textColor"
      [imgMobile]="cmsPage.jumbotron?.default?.imageMobile"
      [imgDesktop]="cmsPage.jumbotron?.default?.imageDesktop"
      [variant]="jumbotronVariant"
      [backLink]="backLink"
      [backLinkAriaLabel]="
        'a11y.attendee.dynamic_page.header.back_link.label' | translate
      "
    >
    </app-attendee-jumbotron>
    <ng-container *ngIf="cmsPage && cmsPage?.sections">
      <app-cms-section
        [section]="section"
        *ngFor="let section of cmsPage?.sections; let index = index"
      ></app-cms-section>
    </ng-container>
  </ng-container>
</app-attendee-dynamic-page-layout>
